/* eslint-disable no-console */
import DOI from "../../../assets/images/incident.svg";
import avatarImg from "../../../assets/images/avatar.svg";
import { formatCalendarDate } from "../../../Utils/helper";
import useNotificationCounts from "../hooks/useNotificationsCount";
import "./provider-list.css";

const ProviderList = ({
  users,
  selectedUser,
  onSelectUser,
  loading,
  error,
  typingUsers,
  unreadCounts,
  _latestMessages,
}) => {
  const { allThreads } = useNotificationCounts();

  console.log(users);
  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#64748b" }}>
        <div
          style={{
            width: "24px",
            height: "24px",
            border: "3px solid #f1f5f9",
            borderTop: "3px solid var(--primary, #3b82f6)",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 12px",
          }}
        />
        <p style={{ margin: 0, fontSize: "14px" }}>Loading Providers...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#ef4444" }}>
        <div style={{ fontSize: "24px", marginBottom: "8px" }}>⚠️</div>
        <p style={{ margin: 0, fontSize: "14px" }}>{error}</p>
      </div>
    );
  }

  // Function to get unique identifier for each user/case
  const getUserKey = (user) => {
    return user.thread_id || user.threadId || user.id || user.case_provider_id;
  };

  // Function to get thread ID for sorting and typing/unread checks
  const getThreadId = (user) => {
    return user.thread_id || user.threadId || user.id;
  };

  const hasThread = (user) =>
    Boolean(user.has_thread || user.thread_id || user.threadId || user.thread_type);

  const getUnreadCount = (user) => {
    if (!hasThread(user)) return 0;

    const threadId = getThreadId(user);
    // The socket's count is authoritative once received; the inbox snapshot and
    // local increments are only fallbacks, otherwise a stale 1 outlives a pushed 0.
    const serverCount = allThreads?.[threadId];
    if (serverCount !== undefined && serverCount !== null) return serverCount;
    return Math.max(unreadCounts?.[threadId] || 0, user.unread_count || 0);
  };

  // case_id is shared by all provider treatments for a case, so it must not be used
  // for deduplication. case_provider_id identifies the individual treatment row.
  const usersByCaseProvider = new Map();

  users.forEach((user, index) => {
    const caseProviderId = user.case_provider_id;
    const caseProviderKey =
      caseProviderId !== undefined && caseProviderId !== null
        ? `case-provider-${caseProviderId}`
        : `unmatched-row-${getUserKey(user) || index}-${index}`;
    const existingUser = usersByCaseProvider.get(caseProviderKey);

    if (!existingUser || (hasThread(user) && !hasThread(existingUser))) {
      usersByCaseProvider.set(caseProviderKey, user);
    }
  });

  const deduplicatedUsers = [...usersByCaseProvider.values()];

  // Sort users by last activity/typing status - exactly like UsersList
  const sortedUsers = [...deduplicatedUsers].sort((a, b) => {
    const aThreadId = getThreadId(a);
    const bThreadId = getThreadId(b);

    // Check if user is typing (only for users with threads)
    const aTyping =
      a.has_thread && typingUsers[aThreadId] && Object.keys(typingUsers[aThreadId]).length > 0;
    const bTyping =
      b.has_thread && typingUsers[bThreadId] && Object.keys(typingUsers[bThreadId]).length > 0;

    if (aTyping && !bTyping) return -1;
    if (!aTyping && bTyping) return 1;

    // Check unread count (only for users with threads)
    const aUnread = getUnreadCount(a);
    const bUnread = getUnreadCount(b);

    if (aUnread > 0 && bUnread === 0) return -1;
    if (aUnread === 0 && bUnread > 0) return 1;

    // Sort by last message time
    const aTime =
      a.thread_last_message_at || a.last_message_preview?.created_at || a.created_at || 0;
    const bTime =
      b.thread_last_message_at || b.last_message_preview?.created_at || b.created_at || 0;

    return new Date(bTime) - new Date(aTime);
  });

  return (
    <div
      style={{ flex: 1, minHeight: 0, overflow: "auto", scrollbarWidth: "none" }}
      className="chat-odd-even-color chat-provider-list"
    >
      {sortedUsers.map((user) => {
        const userThreadId = getThreadId(user);
        const userUnreadCount = getUnreadCount(user);
        const isTyping =
          user.has_thread &&
          typingUsers[userThreadId] &&
          Object.keys(typingUsers[userThreadId]).length > 0;

        // Use case_display as the main display name
        const _displayName = user.case_display || user.name || "Unknown Case";

        return (
          <div
            key={getUserKey(user)}
            onClick={() => onSelectUser(user)}
            className="onHoverChat"
            style={{
              paddingLeft: "0px",
              borderBottom: "1px solid #f1f5f9",
              cursor: "pointer",
              // backgroundColor: selectedUser?.case_id === user.case_id ? "#f0f7ff" : "transparent",
              // backgroundColor:
              //   selectedUser?.case_id === user.case_id ? "var(--primary-20)" : "var(--primary-5)",
              color: selectedUser?.case_id === user.case_id ? "black" : "black",
              // borderRight:
              //   selectedUser?.case_id === user.case_id
              //     ? "3px solid var(--primary, #3b82f6)"
              //     : "none",
              // transition: "all 0.2s ease",
              position: "relative",
            }}
            // onMouseEnter={(e) => {
            //   if (selectedUser?.case_id !== user.case_id) {
            //     e.target.style.backgroundColor = "var(--primary-20)";
            //   }
            // }}
            // onMouseLeave={(e) => {
            //   if (selectedUser?.case_id !== user.case_id) {
            //     e.target.style.backgroundColor = "var(--primary-5)";
            //   }
            // }}
          >
            {isTyping && (
              <div
                style={{
                  position: "absolute",
                  top: "17px",
                  right: "8px",
                  color: "#10b981",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                typing...
              </div>
            )}
            {userUnreadCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "4px",
                  right: "8px",
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "9px",
                  minWidth: "18px",
                  height: "18px",
                  padding: "0 4px",
                  fontSize: "10px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 10,
                }}
              >
                {userUnreadCount > 99 ? "99+" : userUnreadCount}
              </span>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "start",
                gap: "0px",
                flexDirection: "column",
                paddingLeft: "5px",
              }}
            >
              <div
                style={{
                  // width: "19px",
                  // height: "19px",
                  // borderRadius: "50%",

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  fontWeight: "600",
                  gap: "5px",
                  fontSize: "14px",
                }}
              >
                {/* {!user.avatar && displayName.charAt(0).toUpperCase()} */}
                <img
                  src={user.client_avatar_url || avatarImg}
                  alt=""
                  width={15}
                  height={15}
                  style={{
                    width: "15px",
                    height: "15px",
                    flexShrink: 0,
                    objectFit: "contain",
                    borderRadius: "50%",
                    backgroundColor: "white",
                  }}
                  // className="d-flex align-items-center justify-content-center"
                />
                {user?.client_name}
              </div>
              <div
                style={{
                  // width: "19px",
                  // height: "19px",
                  // borderRadius: "50%",
                  // backgroundColor:
                  //   selectedUser?.case_id === user.case_id ? "var(--primary)" : "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  // color: selectedUser?.case_id === user.case_id ? "white" : "black",
                  fontWeight: "600",
                  gap: "5px",
                  fontSize: "14px",
                }}
              >
                {/* {!user.avatar && displayName.charAt(0).toUpperCase()} */}
                {user?.case_type_icon && (
                  <img
                    src={user?.case_type_icon}
                    alt=""
                    width={15}
                    height={15}
                    style={{
                      width: "15px",
                      height: "15px",
                      flexShrink: 0,
                      objectFit: "contain",
                      // borderRadius: "50%",
                    }}
                    // className="d-flex align-items-center justify-content-center"
                  />
                )}
                {user?.case_type_name}
              </div>
              <div
                style={{
                  // width: "19px",
                  // height: "19px",
                  // borderRadius: "50%",
                  // backgroundColor:
                  //   selectedUser?.case_id === user.case_id ? "var(--primary)" : "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  // color: selectedUser?.case_id === user.case_id ? "white" : "black",
                  fontWeight: "600",
                  gap: "5px",
                  fontSize: "14px",
                }}
              >
                {/* {!user.avatar && displayName.charAt(0).toUpperCase()} */}
                <img
                  src={DOI}
                  alt=""
                  width={15}
                  height={15}
                  style={{
                    width: "15px",
                    height: "15px",
                    flexShrink: 0,
                    objectFit: "contain",
                    // borderRadius: "50%",
                  }}
                  // className="d-flex align-items-center justify-content-center"
                />
                {formatCalendarDate(user?.incident_date)}
              </div>
              {/* <div style={{ flex: 1 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "4px",
                  }}
                >
                  <h6
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      fontWeight: "600",
                      color:
                        selectedUser?.case_id === user.case_id
                          ? "var(--primary, #3b82f6)"
                          : "#1e293b",
                    }}
                  >
                    {displayName}
                  </h6>
                  {user.specialty_name && (
                    <span
                      style={{
                        fontSize: "10px",
                        color: "#64748b",
                        background: "#f8fafc",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        marginLeft: "8px",
                      }}
                    >
                      {user.specialty_name}
                    </span>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12px",
                      color: isTyping ? "#10b981" : "#64748b",
                      display: "-webkit-box",
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      flex: 1,
                      fontStyle: isTyping ? "italic" : "normal",
                    }}
                  >
                    {isTyping
                      ? "typing..."
                      : user.has_thread
                        ? latestMessages[userThreadId] ||
                          user.last_message_preview?.content ||
                          "Start a conversation"
                        : "Start a conversation"}
                  </p>
                  {userUnreadCount > 0 && (
                    <span
                      style={{
                        backgroundColor: "var(--primary, #3b82f6)",
                        color: "white",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        fontSize: "10px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "8px",
                      }}
                    >
                      {userUnreadCount}
                    </span>
                  )}
                </div>
              </div> */}
            </div>
          </div>
        );
      })}
      <div className="chat-provider-filler" aria-hidden="true" />
    </div>
  );
};

export default ProviderList;
